import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import DetailView from "../../components/details/DetailView";
import {
  fetchPaymentById,
  deletePayment,
  clearDetail as clearPaymentDetail,
} from "../../redux/slices/paymentSlice";

export default function PaymentInfo() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { detail: payment, detailStatus, error } = useSelector(
    (state) => state.payment
  );

  // Fetch Payment by ID
  useEffect(() => {
    if (id) dispatch(fetchPaymentById(id));
    return () => dispatch(clearPaymentDetail());
  }, [dispatch, id]);

  if (detailStatus === "loading") return <div className="px-20 pt-10">Loading …</div>;
  if (detailStatus === "failed")
    return <div className="px-20 pt-10">Failed to load Payment. {error}</div>;
  if (!payment) return <div className="px-20 pt-10">Payment not found.</div>;

  // Handlers
  const handleDelete = () => {
    dispatch(deletePayment(id));
    navigate(-1); // go back after deletion
  };

  const handleEdit = () => {
    navigate(`/payments/${id}/edit`);
  };

  return (
    <DetailView
      title="Payment Details"
      type="payment"
      data={payment}
      onDelete={handleDelete}
      onEdit={handleEdit}
    />
  );
}
